import $ from "jquery";

/**
 * @constructor
 * @class FP
 */
class HTTPSender {
  static BEARER = null;
  static REQUESTS = [];

  static SetBearer(bearer) {
    if (bearer && (HTTPSender.BEARER == null || HTTPSender.BEARER != bearer)) {
      HTTPSender.BEARER = "Bearer " + bearer;
    }
  }
  static AbortAll = function () {
    HTTPSender.REQUESTS.forEach((r) => r.abort());
    HTTPSender.BEARER = null;
  };

  static SendR = function (verb, dataToSend, urlserver, prefix, responseType, queryParams) {
    //console.info("HTTP: " + prefix);
    //console.info(dataToSend)
    var queryString = "";
    if (queryParams) {
      queryString = "?" + $.param(queryParams);
    }
    var dataO = {
      //timeout: 3000,
      type: verb,
      async: true,
      url: urlserver + prefix + queryString,
      crossDomain: true,
      // dataType: "json",
      contentType: "json",
      //xhrFields: { withCredentials: true },
      //processData: false,
      beforeSend: function (/** @type {JQueryXHR} */ xhr) {
        if (HTTPSender.BEARER) {
          xhr.setRequestHeader("Authorization", HTTPSender.BEARER);
        }
        xhr.setRequestHeader("Accept", "application/json");

        //xhr.setRequestHeader("Access-Control-Request-Headers", "access-control-allow-origin, allow-control-allow-credentials, Origin, X-Requested-With, Content-Type, Accept")
        //xhr.setRequestHeader('Access-Control-Allow-Origin', urlserver);
        //xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
        //xhr.setRequestHeader('Content-Type', 'application/octet-stream');
        //xhr.setRequestHeader('Content-Type', contentType);

        xhr.setRequestHeader("Content-Type", "application/json");

        //xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        HTTPSender.REQUESTS.push(xhr);
      },
      complete: function (xhr) {
        HTTPSender.REQUESTS.splice(HTTPSender.REQUESTS.indexOf(xhr), 1);
        //console.info(JSON.stringify(xhr.responseJSON));
      },
    };
    //dataO.contentType = "json";
    if (responseType) {
      dataO.xhr = function () {
        var xhr = new XMLHttpRequest();
        xhr.responseType = responseType;
        return xhr;
      };
    }
    dataO.data = dataToSend;

    return $.ajax(dataO);
  };

  static SendMultiplePostR = function (arrayOfDataToSend, urlserver, prefix, responseType, queryParams, done, fail) {
    $.when(...arrayOfDataToSend.map(d => HTTPSender.SendPOSTreq(JSON.stringify(d), urlserver, prefix, responseType, queryParams)))
      .then(done, fail);
  }
  // static SendPOSTreq = function(dataToSend, urlserver, prefix, contentType) {
  //     return HTTPSender.SendR(true, dataToSend, urlserver, prefix, contentType, null);
  //}

  static SendPOSTreq = function (dataToSend, urlserver, prefix, responseType, queryParams) {
    return HTTPSender.SendR("POST", dataToSend, urlserver, prefix, responseType, queryParams);
  };

  // static SendGETreq = function(urlserver, prefix, responseType) {
  //     return HTTPSender.SendR(false, null, urlserver, prefix, responseType,  null);
  // }

  static SendGETreq = function (urlserver, prefix, responseType, queryParams) {
    return HTTPSender.SendR("GET", null, urlserver, prefix, responseType, queryParams);
  };
}
export default HTTPSender;
